import { normalize, schema } from 'normalizr';

import { EntityKey, type WhitelistUser, type WhitelistUserById } from '../types';

const whitelistItemSchema = new schema.Entity<WhitelistUser>(EntityKey.WHITELIST_USERS);
const whitelistSchema = new schema.Array<WhitelistUser>(whitelistItemSchema);

export const normalizeWhitelistItem = (data: any) =>
    normalize<
        WhitelistUser,
        {
            [EntityKey.WHITELIST_USERS]: WhitelistUserById;
        },
        WhitelistUser['id']
    >(data, whitelistItemSchema);
export const normalizeWhitelist = (data: any) =>
    normalize<
        WhitelistUser,
        {
            [EntityKey.WHITELIST_USERS]: WhitelistUserById;
        },
        WhitelistUser['id'][]
    >(data, whitelistSchema);
